import { render, staticRenderFns } from "./mark-score-board.vue?vue&type=template&id=3a297361&scoped=true"
import script from "./mark-score-board.vue?vue&type=script&lang=js"
export * from "./mark-score-board.vue?vue&type=script&lang=js"
import style0 from "./mark-score-board.vue?vue&type=style&index=0&id=3a297361&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a297361",
  null
  
)

export default component.exports